module.exports = __webpack_public_path__ + "img/03_es_mi_meg_igy_is_tovab_elunk-03 copy.6d331b86.jpg";